import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import Router, { useRouter } from 'next/router';
import { Skeleton } from 'antd';
import { useQuery, useMutation } from '@apollo/react-hooks';
import styled from 'styled-components';
import Layout from '../../components/Layout';
import TopButton from '../../components/TopButton';
import OptionSelection from '../../components/OptionSelection';
import ShopTabs from '../../components/ShopTabs';
import ShopReviews from '../../components/ShopReviews';
import * as Queries from '../eatmarket/queries';
import * as AuthQueries from '../auth/queries';
import * as DiagnosisReportQueries from '../diagnosisReport/queries';
import { DetailRealClickTrackingScript } from '../../lib/addRealClickScript';

const EatmarketDetail = () => {
  const router = useRouter();
  // const today = moment()
  //   .locale('ko')
  //   .format('YYYYMMDDHH LT');
  const code = _.get(router, 'query.code');
  const { data: productData, loading: productLoading } = useQuery(Queries.PRODUCT, {
    variables: {
      code: typeof code === 'string' ? code.split('?')[0] || code : null
    },
    fetchPolicy: 'no-cache'
  });
  const product = _.get(productData, 'product');
  const image = _.get(product, 'images.0.image');
  const { id, content, description, unit, volume, deliveryType, origin, packageType, expiryDate, name, shortDescription } = product || {};
  const SUBSCRIPTION = id === '37';
  const SUBSCRIPTION1 = id === '38';
  const KIDNEY_TRIAL = id === '65';
  const LOW_SALT = id === '39';
  const DIABETES = id === '40';

  const CANCER = id === '41' || id === '54';
  const CANCER_CUSTOM_PRICE = id === '54';

  const productOptions = _.get(product, 'options');
  const firstOption = _.get(product, 'options.0');
  const { price, discountedPrice } = firstOption || {};
  const onSaleProducts = _.filter(productOptions, productOption => productOption.onSale);
  const [updateVariants] = useMutation(Queries.UPDATE_VARIANTS);
  const { data: variantsData } = useQuery(Queries.VARIANTS);
  const variants = _.get(variantsData, 'variants');
  const storeEl = useRef(null);
  const [topActive, setTopActive] = useState(false);
  const [state, setState] = useState(false);
  const [sendGA, setSendGA] = useState(false);
  const {
    data: {
      auth: { isLoggedIn }
    }
  } = useQuery(AuthQueries.AUTH);
  const handleOptionSelect = () => {
    try {
      setState(true);
      if (!isLoggedIn) {
        setState(false);
        Router.push({
          pathname: '/login',
          query: { redirectTo: router.asPath, code }
        }).then(() => {
          window.scrollTo(0, 0);
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [active, setActive] = useState({
    state: false,
    name: 'information'
  });
  const { data: allRecordResultData } = useQuery(DiagnosisReportQueries.ALL_RECORD_RESULT);
  const allRecordResult = _.get(allRecordResultData, 'allRecordResult');
  const allRecordResultExist = !_.isEmpty(allRecordResult);
  const handleSubscription = diseaseName => {
    if (!isLoggedIn) {
      router
        .push({
          pathname: '/login',
          query: { redirectTo: `/diagnosis?disease=${diseaseName}${CANCER_CUSTOM_PRICE ? '&custom_price=true' : ''}` }
        })
        .then(() => {
          window.scrollTo(0, 0);
        });
    } else {
      router
        .push({
          pathname: '/diagnosis',
          query: {
            disease: diseaseName,
            ...(CANCER_CUSTOM_PRICE && { custom_price: true })
          }
        })
        .then(() => {
          window.scrollTo(0, 0);
        });
    }
  };

  const handleScroll = () => {
    const documentTop = document.documentElement.scrollTop;
    const refTop = storeEl.current ? storeEl.current.offsetTop : 0;
    if (documentTop > refTop) {
      setTopActive(true);
    } else {
      setTopActive(false);
    }
  };
  const addKakaoJS = () => {
    const script = document.createElement('script');
    script.id = 'kakaoScript';
    script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
    script.onload = () => {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init('2a69a0446e3317ecca852b731a4ec430');
      }
    };
    document.body.appendChild(script);
  };

  const removeKaKaoJS = () => {
    const script = document.querySelector('#kakaoScript');
    document.body.removeChild(script);
  };

  // const onLink = () => {
  //   window.Kakao.Link.createCustomButton({
  //     container: '#create-kakao-link-btn',
  //     templateId: 59641
  //   });
  // };

  // Setting GA : 상세페이지 조회 (일반&식단 주문 동일)
  useEffect(() => {
    if (!product || !price || !discountedPrice) return;

    if (!sendGA && window.dataLayer) {
      window.dataLayer.push({
        event: 'view_item',
        hurdlers_ga4: {
          items: [
            {
              item_id: _.get(product, 'id', ''),
              item_name: _.get(product, 'name', ''),
              item_category: _.get(product, 'productCategory.name', ''),
              price,
              quantity: 1,
              discount: discountedPrice,
              item_type: _.get(product, 'code', '')
            }
          ]
        }
      });
      setSendGA(true);
    }
  }, [product, sendGA]);

  useEffect(() => {
    if (!id) return () => {};

    const script = DetailRealClickTrackingScript({ realItem: id });
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [id]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    if (code === 'lowsugarsub') addKakaoJS();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (code === 'lowsugarsub') removeKaKaoJS();
    };
  }, []);
  if (productLoading) {
    return <Skeleton active />;
  }
  const handleClick = () => {
    if (SUBSCRIPTION || SUBSCRIPTION1) {
      handleSubscription('kidney');
    } else if(KIDNEY_TRIAL) {
      handleSubscription('kidney_trial');
    }else if (LOW_SALT) {
      handleSubscription('lowsalt');
    } else if (DIABETES) {
      handleSubscription('diabetes');
    } else if (CANCER) {
      handleSubscription('cancer');
    } else {
      handleOptionSelect();
    }
  };

  return (
    <Layout store withFooter={false}>
      {topActive && active?.name === 'information' && <TopButton />}
      <DesktopDiv>
        <Image>
          <img src={image} alt="대표이미지" />
        </Image>
        <DesktopDetailContainer>
          <Brand>맛있저염</Brand>
          <Title>{name}</Title>
          <Description>{description}</Description>
          <PriceBox>
            <Price>{discountedPrice && discountedPrice.toLocaleString()}원</Price>
            {price ? <DiscountedPrice>{price.toLocaleString()}원</DiscountedPrice> : null}
          </PriceBox>
          {!isLoggedIn && (
            <Benefit>
              <Tag>적립혜택</Tag>
              로그인 후, 적립혜택 이용 가능
            </Benefit>
          )}
        </DesktopDetailContainer>
      </DesktopDiv>
      <Container>
        <Div>
          <DetailContainer>
            <Brand>맛있저염</Brand>
            <Title>{name}</Title>
            <Description>{description}</Description>
            <PriceBox>
              <Price>{discountedPrice && discountedPrice.toLocaleString()}원</Price>
              {price ? <DiscountedPrice>{price.toLocaleString()}원</DiscountedPrice> : null}
            </PriceBox>
            {!isLoggedIn && (
              <Benefit>
                <Tag>적립혜택</Tag>
                로그인 후, 적립혜택 이용 가능
              </Benefit>
            )}
          </DetailContainer>
        </Div>
        <Div ref={storeEl}>
          {unit && (
            <Label>
              <label>판매단위</label>
              <span>{unit}</span>
            </Label>
          )}
          {volume && (
            <Label>
              <label>중량/용량</label>
              <span>{volume}</span>
            </Label>
          )}
          {deliveryType && (
            <Label>
              <label>배송구분</label>
              <span>{deliveryType}</span>
            </Label>
          )}
          {origin && (
            <Label>
              <label>원산지</label>
              <span>{origin}</span>
            </Label>
          )}
          {packageType && (
            <Label>
              <label>포장타입</label>
              <span>{packageType}</span>
            </Label>
          )}
          {expiryDate && (
            <Label>
              <label>유통기한</label>
              <span>{expiryDate}</span>
            </Label>
          )}
          {shortDescription && (
            <Label>
              <label>안내사항</label>
              <span>{shortDescription}</span>
            </Label>
          )}
        </Div>
        <ShopTabs active={active} setActive={setActive} />
        {/* {active.name === 'information' && code === 'lowsugarsub' && today < '2021083012' && (
          <>
            <SharePage>
              <img src="https://microsalts-media.s3.ap-northeast-2.amazonaws.com/media/images/share-event.jpg"></img>
              <ShareButton id="create-kakao-link-btn" onClick={onLink}>
                <img src="https://microsalts-media.s3.ap-northeast-2.amazonaws.com/media/images/kakao-link.png"></img>
              </ShareButton>
            </SharePage>
          </>
        )}
        {active.name === 'information' && code === 'lowsugarsub' && today > '2021083012' && (
          <>
            <SharePage>
              <img src="https://microsalts-media.s3.ap-northeast-2.amazonaws.com/media/images/share-event2.jpg"></img>
              <ShareButton id="create-kakao-link-btn" onClick={onLink}>
                <img src="https://microsalts-media.s3.ap-northeast-2.amazonaws.com/media/images/kakao-link.png"></img>
              </ShareButton>
            </SharePage>
          </>
        )} */}
        {active.name === 'information' ? <DetailPage dangerouslySetInnerHTML={{ __html: content }} /> : <ShopReviews />}
        <Button onClick={handleClick}>상품 구매하기</Button>
        {state && <OptionSelection updateVariants={updateVariants} variants={variants} product={product} productOptions={onSaleProducts} state={state} setState={setState} />}
      </Container>
    </Layout>
  );
};
const Container = styled.div`
  padding: 0 0 7.8rem 0;
  ${props => props.theme.device.md} {
    max-width: 992px;
    padding: 0;
    margin: 0 auto;
    padding-bottom: 10rem;
  }
`;
const DesktopDiv = styled.div`
  ${props => props.theme.device.md} {
    display: flex;
    max-width: 992px;
    margin: 5rem auto;
    flex-direction: row;
    justify-content: space-around;
  }
`;
const Div = styled.div`
  padding: 2.4rem 1.6rem;
`;
const Image = styled.div`
  display: flex;
  justify-content: center;
  overflow: hidden;
  img {
    max-width: 375px;
    max-height: 375px;
    width: 100%;
    height: auto;
  }
  ${props => props.theme.device.md} {
    margin-right: 5rem;
  }
`;
const DetailContainer = styled.div`
  ${props => props.theme.device.md} {
    display: none;
  }
`;
const DesktopDetailContainer = styled.div`
  display: none;
  ${props => props.theme.device.md} {
    display: block;
  }
`;
const Brand = styled.span`
  display: inline-block;
  margin-bottom: 8px;
  border: 1px solid #ff7e1f;
  color: #ff7e1f;
  font-size: 1.4rem;
  font-weight: 700;
  padding: 0.3rem;
`;
const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
`;
const Description = styled.h2`
  font-size: 1.4rem;
  color: #b2b2b2;
  font-weight: 700;
  white-space: pre-line;
`;
const PriceBox = styled.div`
  margin-bottom: 1.2rem;
`;
const Price = styled.span`
  font-size: 2rem;
  font-weight: 800;
`;
const DiscountedPrice = styled.span`
  font-size: 1.7rem;
  color: #b2b2b2;
  text-decoration: line-through;
  margin-left: 1rem;
`;
const Benefit = styled.div`
  color: #ff7e1f;
  font-weight: 700;
  font-size: 1.2rem;
  ${props => props.theme.device.md} {
    font-size: 1.4rem;
  }
`;
const Tag = styled.span`
  font-size: 1rem;
  display: inline-block;
  padding: 0.2rem 0.5rem;
  margin-right: 0.5rem;
  border-radius: 5px;
  color: #fff;
  background-color: #ff7e1f;
  ${props => props.theme.device.md} {
    font-size: 1.2rem;
  }
`;
const Label = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 1.4rem;
  font-weight: 700;
  padding-bottom: 2rem;
  label {
    color: #b2b2b2;
    flex: 1;
  }
  span {
    flex: 2;
    white-space: pre-line;
  }
  ${props => props.theme.device.md} {
    font-size: 1.6rem;
  }
`;
const DetailPage = styled.div`
  img {
    width: 100%;
  }
  margin-top: 2.4rem;
  ${props => props.theme.device.md} {
    width: 600px;
    margin: 0 auto;
  }
`;
const Button = styled.a`
  z-index: 15;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 5.4rem;
  line-height: 4.8rem;
  font-size: 1.6rem;
  text-align: center;
  font-weight: 700;
  width: 100%;
  background-color: #ff7e1f;
  color: #fff;
  &:hover {
    color: #fff;
  }
  ${props => props.theme.device.md} {
    height: 6rem;
    line-height: 6rem;
    font-size: 1.8rem;
  }
`;
// const SharePage = styled.div`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   img {
//     width: 100%;
//   }
//   margin-top: 2.4rem;
//   ${props => props.theme.device.md} {
//     width: 1024px;
//     margin: 0 auto;
//   }
// `;
// const ShareButton = styled.a`
//   position: absolute;
//   bottom: 11rem;
//   padding: 0px 6rem;
//   ${props => props.theme.device.md} {
//     bottom: 31rem;
//     padding: 0px 18rem;
//   }
// `;
export default EatmarketDetail;
